var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"word-image-container d-flex justify-center pa-0",attrs:{"cols":"7","sm":"7","md":"6","lg":"6","xl":"6"}},[_c('v-img',{staticClass:"word-image",attrs:{"contain":"","src":_vm.image,"alt":_vm.alt,"max-height":"600","max-width":"400","eager":""},on:{"load":_vm.loaded,"loadstart":_vm.loadStart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }